<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      currentPageName: '',
    }
  },
  mounted() {

    let goUrl = this.isMobile();
    if (goUrl === 1) {
       //移动端地址
        window.location.href ='https://www.arccer.com/mobile';
        // window.location.href =' http://websitetest.shenghuayule.net/arccer/mobile'
    }else{
        // 初始化菜单
        // util.initRouter(this);
        this.currentPageName = this.$route.name;
        // 显示打开的页面的列表
         this.$router.push({ name: this.currentPageName})
    }
  

  },
  methods:{
        isMobile(){
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            // localStorage.setItem('isiphone',flag)
            localStorage.setItem('ismobile',flag?1:0);
            let goUrl = flag ? 1 : 0;
            return goUrl;
        }
    }
}
</script>

<style>
#app {
  font-family:tahoma,arial,'Hiragino Sans GB','\5b8b\4f53',sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// src/App.vue